class AccordionShowMore extends HTMLElement {
  #rows = [];
  #button;

  connectedCallback() {
    const visibleRows = parseInt(this.dataset.visibleRows, 10) || 0;

    this.#rows = Array.from(this.querySelectorAll(':scope > .accordion > accordion-custom'));
    this.#button = this.querySelector('.accordion-show-more__button');

    if (!this.#button || this.#rows.length <= visibleRows) return;

    this.#rows.slice(visibleRows).forEach((row) => {
      row.hidden = true;
    });

    this.#button.hidden = false;
    this.#button.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#handleClick);
  }

  #handleClick = () => {
    const isExpanded = this.dataset.expanded === 'true';
    const visibleRows = parseInt(this.dataset.visibleRows, 10) || 0;

    this.#rows.slice(visibleRows).forEach((row) => {
      row.hidden = isExpanded;
    });

    this.dataset.expanded = String(!isExpanded);
    this.#button.setAttribute('aria-expanded', String(!isExpanded));
  };
}

if (!customElements.get('accordion-show-more')) {
  customElements.define('accordion-show-more', AccordionShowMore);
}
